import React from "react"
import "./styles.css"
import { connect } from "react-redux"
import AuthActions from "redux-store/models/auth"
import { printFatturaReq } from "services/auth"
import DatePicker from "./DatePicker"
import { Loader } from "shared-components"
import {
  Select,
  Pagination,
  Table,
  Button,
  Input,
  Icon,
  Tooltip,
  message,
} from "antd"
import { b64toBlob } from "utils"
import {
  printAllFatturaReq,
  recalculateUserFatturaReq,
} from "../../../services/auth"

const { Option } = Select

class NewFaturaDomain extends React.Component {
  state = {
    yearChosen: (() => {
      const date = new Date()
      date.setMonth(date.getMonth() - 1)
      return date.getFullYear().toString()
    })(),

    monthChosen: (() => {
      const date = new Date()
      date.setMonth(date.getMonth() - 1)

      return {
        id: date.getMonth() + 1,
        name: date.toLocaleString("it-IT", { month: "long" }),
      }
    })(),

    monthDropdown: false,
    yearDropdown: false,
    calendarVis: false,
    userName: null,
    userListShow: false,
    perPage: 25,
    page_number: 1,
    clickedPage: 1,
    raport: null,
    printingAllFatture: false,
  }
  setCalendar = (val) => {
    this.setState({ calendarVis: val })
  }

  handleSubmit = (e) => {
    e.preventDefault()
  }
  convertB64ToBolbThenPrnt(file_name, open) {
    printFatturaReq(file_name).then(async (response) => {
      var myBlob = b64toBlob(response.data.base64, "application/pdf")
      var objectURL = URL.createObjectURL(myBlob)
      document.querySelector("#pdf-frame").src = ""
      document.querySelector("#pdf-frame").src = objectURL

      if (open) {
        window.open(
          objectURL,
          "_blank",
          "toolbar=no,scrollbars=no,resizable=no,top=50,left=500,width=1024,height=700",
        )
      } else {
        window.setTimeout(function () {
          document.querySelector("#pdf-frame").contentWindow.print()
        }, 1000)
      }
      objectURL = URL.revokeObjectURL(myBlob)
    })
  }

  printAllFatture = async () => {
    this.setState({ printingAllFatture: true })

    try {
      const { yearChosen, monthChosen } = this.state

      const response = await printAllFatturaReq(yearChosen, [monthChosen.id])

      if (response?.error) {
        console.error("Error downloading fatture:", response.error)
        return
      }

      const url = URL.createObjectURL(response.data)

      const link = document.createElement("a")
      link.href = url
      link.download = `fatture-${yearChosen}-${monthChosen.id}.zip`

      document.body.appendChild(link)
      link.click()
      link.remove()

      URL.revokeObjectURL(url)
    } catch (error) {
      console.error("Error downloading fatture:", error)
    } finally {
      this.setState({ printingAllFatture: false })
    }
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys }) => {
      if (dataIndex === "user") {
        return (
          <div
            style={{ padding: 8, width: "180px" }}
            className="table-filter-dropdown"
          >
            <Select
              mode="single"
              allowClear
              showSearch={true}
              style={{ width: "100%" }}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys}
              onChange={(value) => {
                setSelectedKeys(value)
                this.setState({ userName: value })
              }}
            >
              {this.props.Users?.map((option) => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
            <Button
              type="primary"
              onClick={() => this.handleSearch()}
              icon="search"
              size="small"
              style={{ marginTop: 8, width: "100%" }}
            >
              Search
            </Button>
          </div>
        )
      }
    },
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    render: (text) => (this.state.searchedColumn === dataIndex ? text : text),
  })

  handleSearch = () => {
    const { userName, monthChosen, yearChosen, perPage, page_number } = this.state
    const { activeSkinId } = this.props
    this.props.getAllFaturaBySearch(
      userName,
      monthChosen.id,
      yearChosen,
      perPage,
      page_number,
      this.props.accountInfo.profile.role.name === "super_admin"
        ? this.state.raport
        : "",
      this.props.accountInfo.profile.role.name === "main_admin"
        ? activeSkinId
        : null,
      this.state.invoiceNumber,
    )
  }

  fetchFatture = (overrides = {}) => {
    const { userName, monthChosen, yearChosen, perPage, page_number, raport } = {
      ...this.state,
      ...overrides,
    }

    const { activeSkinId, accountInfo } = this.props
    const role = accountInfo.profile.role.name

    console.log(activeSkinId)

    this.props.getAllFaturaBySearch(
      userName || null,
      monthChosen?.id || null,
      yearChosen || null,
      perPage,
      page_number,
      raport,
      role === "main_admin" ? activeSkinId : null,
      this.state.invoiceNumber,
    )
  }

  componentDidMount() {
    this.fetchFatture({
      perPage: 25,
      page_number: 1,
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeSkinId !== this.props.activeSkinId) {
      this.fetchFatture({ page_number: 1 })
    }
  }

  render() {
    const { faturaDetails, Users, total_pages, screenWidth } = this.props

    var columns =
      screenWidth < 550
        ? [
            {
              title: "Date / Ora",
              dataIndex: "time",
              key: "time",
              ellipsis: true,
              width: "18%",
            },
            {
              title: "User",
              dataIndex: "user",
              key: "user",
              ellipsis: true,
              width: "12%",
              ...this.getColumnSearchProps("user"),
              render: (text) => (
                <>
                  <i className="fal fa-store"></i>
                  {text}
                </>
              ),
            },
            {
              title: "Operazione",
              dataIndex: "operazione",
              key: "operazione",
              ellipsis: true,
              width: "10%",
              align: "center",
              render: (text, record) => {
                console.log(record)
                return (
                  <div className="operazione">
                    <i
                      onClick={() => {
                        this.convertB64ToBolbThenPrnt(record.file_name, "open")
                      }}
                      className="far fa-file-pdf"
                    ></i>
                    <i
                      className="far fa-print"
                      onClick={() => {
                        this.convertB64ToBolbThenPrnt(record.file_name)
                      }}
                    ></i>
                    <iframe
                      id="pdf-frame"
                      title="pdf-frame-fattura"
                      style={{ display: "none" }}
                    ></iframe>
                    <i
                      className="far fa-envelope-open-text"
                      onClick={() => {
                        this.props.sendMailFattura(record.file_name)
                      }}
                    ></i>
                  </div>
                )
              },
            },
          ]
        : [
            {
              title: "Numero",
              dataIndex: "numero",
              key: "numero",
              ellipsis: true,
              width: "12%",
              render: (text, record) => <span>{record.reference}</span>,
            },
            {
              title: "Date / Ora",
              dataIndex: "time",
              key: "time",
              ellipsis: true,
              width: "18%",
            },
            {
              title: "User",
              dataIndex: "user",
              key: "user",
              ellipsis: true,
              width: "12%",
              ...this.getColumnSearchProps("user"),
              render: (text) => (
                <>
                  <i className="fal fa-store"></i>
                  {text}
                </>
              ),
            },
            {
              title: "Descrizione",
              dataIndex: "descrizione",
              key: "descrizione",
              ellipsis: true,
              width: "18%",
            },
            {
              title: "Importo",
              dataIndex: "importo",
              key: "importo",
              ellipsis: true,
              align: "right",
              render: (text) => `${text}€`,
              width: "10%",
            },
            {
              title: "Commissione",
              dataIndex: "commissione",
              key: "commissione",
              ellipsis: true,
              align: "right",
              render: (text) => `${text}€`,
              width: "10%",
            },
            {
              title: "Proviggione",
              dataIndex: "proviggione",
              key: "proviggione",
              ellipsis: true,
              align: "right",
              render: (text) => `${text}€`,
              width: "10%",
            },
            {
              title: "Operazione",
              dataIndex: "operazione",
              key: "operazione",
              ellipsis: true,
              width: "10%",
              align: "center",
              render: (text, record) => {
                console.log(record)
                return (
                  <div className="operazione">
                    <Tooltip title="Apri fattura">
                      <i
                        onClick={() => {
                          this.convertB64ToBolbThenPrnt(record.file_name, "open")
                        }}
                        className="far fa-file-pdf"
                      />
                    </Tooltip>

                    <Tooltip title="Stampa fattura">
                      <i
                        className="far fa-print"
                        onClick={() => {
                          this.convertB64ToBolbThenPrnt(record.file_name)
                        }}
                      />
                    </Tooltip>

                    <Tooltip title="Invia fattura">
                      <i
                        className="far fa-envelope-open-text"
                        onClick={() => {
                          this.props.sendMailFattura(record.file_name)
                        }}
                      />
                    </Tooltip>

                    <Tooltip title="Ricalcola fattura">
                      <i
                        className="far fa-sync-alt"
                        onClick={async () => {
                          const [, month, year] = record.time.split("/")

                          const response = await recalculateUserFatturaReq(
                            record.user,
                            Number(month),
                            Number(year),
                          )

                          if (!response?.error) {
                            message.success(
                              `La fattura per l'utente ${response.username} è stata ricalcolata con successo.`,
                            )
                          }
                        }}
                      />
                    </Tooltip>

                    <iframe
                      id="pdf-frame"
                      title="pdf-frame-fattura"
                      style={{ display: "none" }}
                    />
                  </div>
                )
              },
            },
          ]

    var data = faturaDetails?.map((f) => ({
      numero: f.numero,
      reference: f.reference,
      time: f.time,
      user: f.user,
      descrizione: f.descrizione,
      importo: f.importo,
      commissione: f.commissione,
      proviggione: f.proviggione,
      file_name: f.file_name,
    }))
    console.log(Users)
    const {
      calendarVis,
      monthDropdown,
      yearDropdown,
      monthChosen,
      yearChosen,
      userName,
      userListShow,
      perPage,
      page_number,
      clickedPage,
    } = this.state
    return (
      <div className="Container" style={{ width: "100%" }}>
        <div className="FaturaDomain">
          <div className="panels-container">
            <div className="row no-gutters ">
              <div className="FauturaFilter">
                {calendarVis && (
                  <DatePicker
                    setMonthDropdown={() => {
                      this.setState((state) => ({
                        monthDropdown: !state.monthDropdown,
                      }))
                    }}
                    setYearDropdown={() => {
                      this.setState((state) => ({
                        yearDropdown: !state.yearDropdown,
                      }))
                    }}
                    setMonthChosen={(month) => {
                      this.setState((state) => ({
                        monthChosen:
                          month.id === state.monthChosen.id
                            ? ""
                            : { id: month.id, name: month.name },
                        monthDropdown: !state.monthDropdown,
                      }))
                    }}
                    setYearChosen={(year) => {
                      this.setState((state) => ({
                        yearChosen: year.name === state.yearChosen ? "" : year.name,
                        yearDropdown: !state.yearDropdown,
                      }))
                    }}
                    yearChosen={yearChosen}
                    monthChosen={monthChosen}
                    monthDropdown={monthDropdown}
                    yearDropdown={yearDropdown}
                  />
                )}
                {screenWidth > 500 && (
                  <div className="FauturaFilter--Header">
                    <div style={{ marginRight: 20 }}>
                      {" "}
                      <img
                        src={require("../../../assets/images/icons/fatture.svg")}
                      />{" "}
                      Fatture
                    </div>

                    <div
                      className="utenti-filters"
                      style={{ display: "flex", gap: 10 }}
                    >
                      <Select
                        allowClear
                        showSearch
                        style={{ width: 200 }}
                        placeholder="Cerca Utente"
                        value={this.state.userName ?? undefined}
                        onChange={(value) => {
                          this.setState({ userName: value })

                          setTimeout(() => {
                            this.handleSearch()
                          }, 200)
                        }}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {this.props.Users?.map((option) => (
                          <Option key={option} value={option}>
                            {option}
                          </Option>
                        ))}
                      </Select>
                    </div>

                    <div
                      className="utenti-filters"
                      style={{ display: "flex", gap: 10 }}
                    >
                      <Select
                        value={this.state.raport ?? undefined}
                        placeholder="Seleziona Report"
                        style={{ width: 200 }}
                        onChange={(value) => {
                          this.setState(
                            {
                              raport: value,
                              clickedPage: 1,
                              page_number: 1,
                            },
                            () => {
                              this.fetchFatture({
                                raport: value,
                                page_number: 1,
                              })
                            },
                          )
                        }}
                        allowClear
                      >
                        <Option value="agency">Report Agenzie</Option>
                        <Option value="agent">Report Agente</Option>
                      </Select>
                    </div>
                    <Input
                      style={{ width: 200, height: 37 }}
                      placeholder="Numero Fattura"
                      suffix={<Icon type="search" />}
                      value={this.state.invoiceNumber}
                      allowClear
                      onChange={(e) => {
                        const value = e.target.value

                        this.setState({ invoiceNumber: value }, () => {
                          setTimeout(() => {
                            this.handleSearch()
                          }, 300)
                        })
                      }}
                    />
                  </div>
                )}

                <div className="FauturaFilter--Options">
                  {/* {screenWidth > 390 && (
                    <>
                      {
                        <React.Fragment>
                          <Select
                            value={this.state.raport ?? undefined}
                            placeholder="Seleziona Report"
                            style={{ marginRight: 10, width: 200 }}
                            onChange={(value) => {
                              this.setState(
                                {
                                  raport: value,
                                  clickedPage: 1,
                                  page_number: 1,
                                },
                                () => {
                                  this.fetchFatture({
                                    raport: value,
                                    page_number: 1,
                                  })
                                },
                              )
                            }}
                            allowClear
                          >
                            <Option value="agency">Report Agenzie</Option>
                            <Option value="agent">Report Agente</Option>
                          </Select>
                        </React.Fragment>
                      }
                    </>
                  )} */}

                  <div className="fatura-filter">
                    <div
                      className={`fatura-filter__calendar ${
                        calendarVis ? "is-open" : ""
                      }`}
                      onClick={(e) => {
                        if (e.target.tagName !== "I") {
                          this.setCalendar(!calendarVis)
                        }
                      }}
                    >
                      <div className="fatura-filter__calendar-left">
                        <i className="fal fa-calendar-alt" />

                        <span>
                          {monthChosen && yearChosen
                            ? `${monthChosen.name} / ${yearChosen}`
                            : "Seleziona la data"}
                        </span>
                      </div>

                      <i
                        className={`fal fa-chevron-${calendarVis ? "up" : "down"}`}
                        onClick={() => this.setCalendar(!calendarVis)}
                      />
                    </div>

                    {/* Filter Button */}
                    <button
                      className="fatura-filter__button"
                      onClick={() => {
                        this.setState({ clickedPage: 1 })
                        this.props.getAllFaturaBySearch(
                          userName,
                          monthChosen.id,
                          yearChosen,
                          perPage,
                          page_number,
                          this.props.accountInfo.profile.role.name === "super_admin"
                            ? this.state.raport
                            : "",
                          this.props.accountInfo.profile.role.name === "main_admin"
                            ? this.props.activeSkinId
                            : null,
                          this.state.invoiceNumber,
                        )
                      }}
                    >
                      Filtra
                    </button>
                  </div>
                  <Button
                    type="primary"
                    icon="download"
                    loading={this.state.printingAllFatture}
                    onClick={this.printAllFatture}
                    style={{ marginLeft: 10 }}
                  >
                    Scarica tutte le fatture
                  </Button>
                </div>
              </div>
            </div>
            <div
              className={
                this.props.accountInfo?.profile.role.name === "agency" ||
                this.props.accountInfo?.profile.role.name === "simple_user"
                  ? "row no-gutters maxWidth"
                  : "row no-gutters"
              }
            >
              {!this.props.fattura_loading ? (
                <Table
                  columns={columns}
                  dataSource={data}
                  pagination={false}
                  rowKey={(record, i) => i}
                />
              ) : (
                <Loader />
              )}
              <div className="paginationWrapper FatturePag">
                <Pagination
                  onChange={(e) => {
                    this.setState({ clickedPage: e })
                    this.props.getAllFaturaBySearch(
                      userName,
                      monthChosen.id,
                      yearChosen,
                      perPage,
                      e,
                      this.props.accountInfo.profile.role.name === "super_admin"
                        ? this.state.raport
                        : "",
                      this.props.accountInfo.profile.role.name === "main_admin"
                        ? this.props.activeSkinId
                        : null,
                      this.state.invoiceNumber,
                    )
                  }}
                  total={total_pages ? total_pages * 10 : 1}
                  current={clickedPage}
                />
                <Select
                  defaultValue={25}
                  onChange={(e) => {
                    this.setState({ perPage: parseInt(e), clickedPage: 1 }, () => {
                      this.props.getAllFaturaBySearch(
                        userName,
                        monthChosen.id,
                        yearChosen,
                        parseInt(e),
                        page_number,
                        this.props.accountInfo.profile.role.name === "super_admin"
                          ? this.state.raport
                          : "",
                        this.props.accountInfo.profile.role.name === "main_admin"
                          ? this.props.activeSkinId
                          : null,
                        this.state.invoiceNumber,
                      )
                    })
                  }}
                  value={this.state.perPage}
                >
                  <Option value={10}>10 / Pagina</Option>
                  <Option value={25}>25 / Pagina</Option>
                  <Option value={50}>50 / Pagina</Option>
                </Select>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mpst = (state) => ({
  faturaDetails: state.auth.Fatture.FaturaDetails,
  total_pages: state.auth.Fatture.total_pages,
  skinExtras: state.auth.skinExtras,
  Users: state.auth.Fatture.Users,
  screenWidth: state.main.screenWidth,
  fattura_loading: state.auth.fattura_loading,
  accountInfo: state.auth.accountInfo,
  activeSkinId: state.main.activeSkinId,
})
export default connect(mpst, AuthActions)(NewFaturaDomain)
